// extracted by mini-css-extract-plugin
export default {"carouselVisiblity":"Carousel_carouselVisiblity__oEVRi"};